import { CSSProperties, FC } from 'react';
import { Col, Row } from 'antd';

import AvatarSkeleton from '../AvatarSkeleton';
import ButtonSkeleton from '../ButtonSkeleton';

interface ListItemSkeletonProps {
    avatar?: boolean;
    avatarShape?: 'circle' | 'square';
    avatarSize?: number | 'large' | 'small' | 'default';
    compact?: boolean;
    lineWidths?: [string, string?];
    style?: CSSProperties;
}

const ListItemSkeleton: FC<ListItemSkeletonProps> = ({
    avatar = false,
    avatarShape = 'circle',
    avatarSize = 16,
    compact,
    lineWidths = ['72%', '48%'],
    style,
}): JSX.Element => (
    <Row align='middle' wrap={false} gutter={[8, 0]} style={style}>
        {avatar && (
            <Col flex='none' style={{ alignItems: 'center', display: 'flex' }}>
                <AvatarSkeleton shape={avatarShape} size={avatarSize} />
            </Col>
        )}
        <Col flex='auto' style={{ minWidth: 0 }}>
            <ButtonSkeleton
                block
                size='small'
                style={{
                    display: 'block',
                    height: compact ? '0.75rem' : '0.875rem',
                    marginBottom: lineWidths[1] ? '0.375rem' : 0,
                    width: lineWidths[0],
                }}
            />
            {lineWidths[1] && (
                <ButtonSkeleton
                    block
                    size='small'
                    style={{
                        display: 'block',
                        height: compact ? '0.625rem' : '0.75rem',
                        width: lineWidths[1],
                    }}
                />
            )}
        </Col>
    </Row>
);

export default ListItemSkeleton;
